import { memo } from "react"

interface CusipWithBenchmarkProps {
  cusip?: string
  benchmark?: string
}

export const CusipWithBenchmark = memo(function CusipWithBenchmark({
  cusip,
  benchmark,
}: CusipWithBenchmarkProps) {
  return (
    <p className="text-sm-regular text-tertiary">
      {cusip ?? "No cusip found"} &#160;&#x2022;&#160;{" "}
      {benchmark ?? "No benchmark available"}
    </p>
  )
})
